import { useHandleResponse } from '@/utils/useHandleResponse';
import { useMutation } from '@tanstack/react-query';
import { App, Button, Checkbox, Col, Divider, Form, Input, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { updateField, updateProps } from '../../../contextRedux/CompanyGroup/CompanyGroupModel';
import CompanyGroupService from '../../../services/companyGroup/CompanyGroupService';
import { RootState } from '../../../store';
import useWindowSize from '../../../utils/useWindowSize';

const CompanyGroupForm: FC<any> = () => {
  const [form] = useForm();
  const dispatch = useDispatch();
  const width = useWindowSize();
  const { message } = App.useApp();
  const handleResponse = useHandleResponse();

  const companyGroup = useSelector((state: RootState) => state.models.companyGroup);

  const initialValues = {
    id: useSelector((state: RootState) => state?.models?.companyGroup?.id),
    name: useSelector((state: RootState) => state?.models?.companyGroup?.name),
    isActive: useSelector((state: RootState) => state?.models?.companyGroup?.isActive),
  };

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const fieldsValue = {
      ...form.getFieldsValue(true),
      isActive: e.target.checked,
    };
    form.setFieldsValue(fieldsValue);
  };

  const onSaveCompanyGroup = async () => {
    saveCompanyGroup(companyGroup);
  };

  const { mutate: saveCompanyGroup, isPending: _isSavingCompanyGroup } = useMutation({
    mutationFn: (formData: any) => CompanyGroupService.upsert(companyGroup.id, formData),
    onSuccess: (data: any) => {
      if (data) {
        handleResponse(data, data?.response?.name);
        dispatch(updateProps({ field: 'isModalVisible', value: false }));
        dispatch(updateProps({ field: 'refresh', value: !companyGroup.props.refresh }));
      }
    },
    onError: (error: any) => {
      message.error(error.message);
    },
  });

  const handleFieldChange = (changedValues: any, _allValues: any) => {
    for (const key in changedValues) {
      dispatch(updateField({ field: key, value: changedValues[key] }));
    }
  };

  useEffect(() => {
    form.setFieldsValue(companyGroup);
  }, [companyGroup]);

  return (
    <Form
      form={form}
      name='companyGroupForm'
      initialValues={initialValues}
      onValuesChange={handleFieldChange}
      onFinish={onSaveCompanyGroup}
      layout='vertical'
    >
      <Divider />

      <Row
        gutter={16}
        style={{
          margin: 0,
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
        }}
      >
        <Col
          span={8}
          style={{
            minWidth: width > 700 ? 300 : '100%',
            padding: 0,
            flex: 'none',
          }}
        >
          <Form.Item label='Denumire' name='name' rules={[{ required: true, message: 'Introdu denumire!' }]}>
            <Input />
          </Form.Item>
        </Col>
        <Col
          span={8}
          style={{
            minWidth: width > 700 ? 300 : '100%',
            padding: 0,
            flex: 'none',
          }}
        >
          <Form.Item label='Status' name='isActive' valuePropName='checked'>
            <Checkbox onChange={() => handleCheckboxChange} />
          </Form.Item>
        </Col>
      </Row>

      <Form.Item>
        <Button type='primary' htmlType='submit'>
          Finalizare
        </Button>
      </Form.Item>
    </Form>
  );
};

export default CompanyGroupForm;
